(function () {
  function initSliders() {
    if (typeof Splide === 'undefined') {
      setTimeout(initSliders, 50);
      return;
    }

    document.querySelectorAll('.hikari-slider__splide').forEach(function (el) {
      if (el.dataset.initialized === '1') return;
      el.dataset.initialized = '1';

      var autoplay = el.dataset.autoplay === 'true';
      var scrollSpeed = parseInt(el.dataset.scrollSpeed, 10) || 1;
      var perPage = parseInt(el.dataset.perPage, 10) || 2;
      var gap = parseInt(el.dataset.gap, 10) || 20;
      var peekPercent = parseInt(el.dataset.peek, 10) || 8;
      var peek = peekPercent + '%';

      var options = {
        type: 'loop',
        perPage: perPage,
        perMove: 1,
        gap: gap + 'px',
        padding: { left: peek, right: peek },
        arrows: true,
        pagination: false,
        drag: 'free',
        focus: 'center',
        speed: 600,
        breakpoints: {
          749: {
            perPage: 1,
            padding: { left: '12%', right: '12%' },
            gap: Math.max(8, Math.floor(gap / 2)) + 'px'
          }
        }
      };

      if (autoplay) {
        options.autoScroll = {
          speed: scrollSpeed,
          pauseOnHover: false,
          pauseOnFocus: false,
          rewind: false
        };
      }

      var extensions = (window.splide && window.splide.Extensions) || {};
      new Splide(el, options).mount(extensions);
    });
  }

  function initLightboxes() {
    document.querySelectorAll('.hikari-slider-section').forEach(function (section) {
      if (section.dataset.lightboxInitialized === '1') return;
      section.dataset.lightboxInitialized = '1';

      var lightbox = section.querySelector('[data-lightbox]');
      if (!lightbox) return;

      var imgEl = lightbox.querySelector('[data-lightbox-img]');
      var closeBtn = lightbox.querySelector('[data-lightbox-close]');
      var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
      var nextBtn = lightbox.querySelector('[data-lightbox-next]');
      var triggers = Array.from(section.querySelectorAll('[data-lightbox-trigger]'));
      if (triggers.length === 0) return;

      var currentIndex = 0;

      function show(index) {
        currentIndex = ((index % triggers.length) + triggers.length) % triggers.length;
        var trigger = triggers[currentIndex];
        var src = trigger.getAttribute('data-full-src');
        var alt = trigger.getAttribute('data-alt') || '';
        imgEl.src = src;
        imgEl.alt = alt;
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
      }

      function hide() {
        lightbox.hidden = true;
        imgEl.src = '';
        document.body.style.overflow = '';
      }

      triggers.forEach(function (trigger, i) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          show(i);
        });
      });

      if (closeBtn) closeBtn.addEventListener('click', hide);
      if (prevBtn) prevBtn.addEventListener('click', function () { show(currentIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(currentIndex + 1); });

      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) hide();
      });

      document.addEventListener('keydown', function (e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') hide();
        else if (e.key === 'ArrowLeft') show(currentIndex - 1);
        else if (e.key === 'ArrowRight') show(currentIndex + 1);
      });
    });
  }

  function init() {
    initSliders();
    initLightboxes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
